<template>
    <div v-if="me.id" class="purchase-order-widgets">
        <orders-purchase-order
            :modal-id="'purchase_order_' + order.id"
            :order="order"
            :admin-mode="isServiceProvider"
            @saved="reloadOrder"
        ></orders-purchase-order>

        <b-modal
            id="modal-error"
            size="sm"
            title="Something went wrong :("
            hide-footer
        >
            <template>
                <div class="d-flex justify-content-between flex-column">
                    <h6>{{ errorMessage }}</h6>
                    <b-button v-if="showUnlockButton" @click="unlockPassports">
                        Unlock Passports
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal id="modal-success" size="sm" title="Success" hide-footer>
            <template>
                <div class="d-flex justify-content-between flex-column">
                    <h6>{{ successMessage }}</h6>
                </div>
            </template>
        </b-modal>

        <b-card no-body class="mb-3">
            <template v-slot:header>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                        {{ $t("Purchase Order") }}
                        {{ order.po_number }}
                    </h5>

                    <b-button
                        variant="primary"
                        :href="`/api/orders/${order.id}/download-csv`"
                        v-if="order.status === 'sent'"
                        class="btn-lte"
                    >
                        <font-awesome-icon :icon="['fas', 'download']" />
                    </b-button>

                    <div v-if="order.status !== 'sent'">
                        <b-button
                            :variant="'outline-primary'"
                            v-if="order.status !== 'sent'"
                            @click="$bvModal.show('purchase_order_' + order.id)"
                        >
                            <font-awesome-icon :icon="['fas', 'pen']" />
                        </b-button>

                        <orders-send-dialog
                            @success="showSuccess"
                            @error="showError"
                            :order="order"
                            :title="'Send '+ order.po_number"
                            v-if="showSendButton"
                            class="ml-2"
                        ></orders-send-dialog>
                    </div>
                </div>
            </template>
            <b-card-body class="pb-0">
                <b-row align-h="between">
                    <b-col lg="5" md="6" sm="12">
                        <div class="p-2">
                            <strong>{{ $t("Order Date") }}</strong>
                            <p>{{ order.order_date }}</p>
                        </div>
                    </b-col>
                    <b-col lg="5" md="6" sm="12">
                        <div class="p-2 border border-info rounded-lg text-center">
                            <div class="font-weight-bold">
                                <font-awesome-icon class="mx-1 text-info" icon="calendar-alt" ></font-awesome-icon>
                                {{ $t("Due Date") }}
                            </div>
                            {{ order.due_date }}
                        </div>
                    </b-col>
                </b-row>

                <b-list-group class="mb-3" flush>
                    <b-list-group-item class="p-1 mb-3">
                        <h5 class="text-muted">{{ $t("From") }}</h5>
                        {{ order.client.name }} <br />
                        {{ order.client.address }} <br />
                        {{ order.client.city }}
                    </b-list-group-item>
                    <b-list-group-item class="p-1 mb-3">
                        <h5 class="text-muted">
                            {{ $t("To") }}
                        </h5>
                        {{ order.manufacturer.name }} <br />
                        {{ order.manufacturer.address }} <br />
                        {{ order.manufacturer.city }}
                    </b-list-group-item>
                    <b-list-group-item v-if="order.final_client" class="p-1 mb-3">
                        <h5 class="text-muted">
                            {{ $t("Final Client") }}
                        </h5>
                        {{ order.final_client }}
                    </b-list-group-item>
                </b-list-group>

            </b-card-body>

            <template v-slot:footer>
                <div v-if="order.status === 'draft'">
                    {{ $t("Last saved") }}
                    {{ lastSaveDate | moment("DD/MM/YYYY HH:mm:ss") }}
                    <b-spinner
                        :label="$t('Saving')"
                        v-if="savingRow"
                        variant="success"
                        small
                    ></b-spinner>
                </div>
                <div v-if="order.status === 'sent'">
                    <span class="text-black-50"
                        >{{ $t("Sent on") }}
                        {{
                            order.date_sent | moment("DD/MM/YYYY HH:mm:ss")
                        }}</span
                    >
                </div>
            </template>
        </b-card>

        <b-card class="mb-3" :header="$t('Comments')" v-if="order.comment">
            <b-card-text>{{ order.comment }}</b-card-text>
        </b-card>

        <b-alert show v-if="order.status === 'sent'"
            >{{ $t("Overall Completion Rate") }} -
            {{ calculateCompletedPercentage(order) }}%
        </b-alert>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  name: "OrdersOrderSummary",
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      showUnlockButton: false
    };
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      order: state => state.purchaseOrders.order,
      lastSaveDate: state => state.purchaseOrders.lastSaveDate,
      savingRow: state => state.purchaseOrders.savingRow
    }),
    isServiceProvider() {
      return this.me.type === "service provider";
    },
    showSendButton() {
      return (
        this.order.status === "draft" &&
        (this.me.type === "client" || this.isServiceProvider)
      );
    }
  },
  methods: {
    ...mapActions({
      getOrder: "purchaseOrders/getOrder"
    }),
    reloadOrder() {
      this.getOrder(this.order.id);
    },
    showSuccess(data) {
      this.successMessage = data.message;
      this.$bvModal.show("modal-success");

      setInterval(() => window.location.replace("/orders"), 3000);
    },
    showError(data) {
      this.errorMessage = data.message;

      if (data.errorCode == 1) {
        this.showUnlockButton = true;
      } else {
        this.showUnlockButton = false;
      }

      this.$bvModal.show("modal-error");
    },
    unlockPassports() {
      window.open("https://www.ionaute.com/", "_blank");
    }
  }
};
</script>
